import axios from 'axios';

export const fetchAvailableAddOns = () => {
  return axios.get('/add-on/list').then((response) => response.data);
};

export const enableAddOn = (code) => {
  return axios.post(`/add-on/enable/${code}`).then((response) => response.data);
};

export const disableAddOn = (code) => {
  return axios.post(`/add-on/disable/${code}`).then((response) => response.data);
};

// ShipStationReturns/ReturnRabbit is such an experimental addOn it doesn't deserve a redux slice
let returnRabbitAddOn = null;
let adminPortalUrl = '';
export const getReturnRabbitAddOn = () => {
  return returnRabbitAddOn;
};

export const getReturnRabbitAdminPortalUrl = () => {
  return adminPortalUrl;
};

export const fetchReturnRabbitAddOn = () => {
  return axios
    .get('/add-on/returnRabbit')
    .then((response) => {
      const { addOn, adminUrl } = response.data;

      returnRabbitAddOn = addOn;
      adminPortalUrl = adminUrl;
      return addOn;
    })
    .catch(() => null);
};

export const configureReturnRabbitAddOn = () => {
  return axios.post('/add-on/returnRabbit').then((response) => {
    const { addOn } = response.data;
    returnRabbitAddOn = addOn;
  });
};
